/**
 *  Panel state module file
**/

export const initialViewState = () => ({
  longitude: 12.5104,
  latitude: 41.8453,
  zoom: 5,
  bearing: 0,
  pitch: 0
})

export const state = {
  viewState: initialViewState()
}
